import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { MessageSquare, ShoppingBag, ScanLine, Pill, ArrowRight, FolderOpen, Plane } from "lucide-react";

const tiles = [
  // GCOMS.ai card hidden from the dashboard while reasoning is seeded.
  // Re-enable by uncommenting this tile (Yunov route + page remain live).
  // { to: "/yunov", name: "GCOMS.ai", tag: "AI Case Consult", icon: MessageSquare, color: "sage", deep: "sage-deep", blurb: "Ask any case question — get reasoned answers." },
  { to: "/coverage", name: "Coverage", tag: "Vacation Coverage", icon: Plane, color: "sky", deep: "sky-deep", blurb: "Request emergency coverage while you're away." },
  { to: "/doc-center", name: "Doc.Center", tag: "Documents & Forms", icon: FolderOpen, color: "terracotta", deep: "terracotta-deep", blurb: "Patient handouts, consent forms, financials, CE." },
  { to: "/drugs", name: "Drugs.rx", tag: "Dental Pharmacology", icon: Pill, color: "moss", deep: "moss-deep", blurb: "Every dental drug — indications & formulations." },
];

const accentBg = { sage: "bg-sage/15", terracotta: "bg-terracotta/15", sky: "bg-sky/15", moss: "bg-moss/15" };
const accentText = { "sage-deep": "text-sage-deep", "terracotta-deep": "text-terracotta-deep", "sky-deep": "text-sky-deep", "moss-deep": "text-moss-deep" };

export default function Dashboard() {
  const { user } = useAuth();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  return (
    <div className="px-8 py-10 lg:px-14 lg:py-16 max-w-6xl">
      <div className="uppercase-label">Dashboard</div>
      <h1 className="font-heading text-4xl lg:text-5xl font-semibold mt-2" data-testid="dashboard-greeting">
        {greeting}, {user?.name?.split(" ")[0]}.
      </h1>
      <p className="text-muted-foreground mt-3 max-w-xl">
        Welcome back to the network. Jump into any module below.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {tiles.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`tile-${t.name.toLowerCase().replace(/[^a-z]/g,'-')}`}
            className="module-card p-8 group"
          >
            <div className="flex items-start justify-between">
              <div className={`w-12 h-12 rounded-md ${accentBg[t.color]} flex items-center justify-center`}>
                <t.icon size={22} className={accentText[t.deep]} />
              </div>
              <ArrowRight size={18} className="text-muted-foreground group-hover:translate-x-1 transition-transform" />
            </div>
            <div className="mt-6 font-heading text-2xl font-semibold">{t.name}</div>
            <div className="uppercase-label mt-1">{t.tag}</div>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{t.blurb}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
